<section class="special-products-two">
    <div class="special-products-two--title" *ngIf="promotionMessage && displayPromotionMessage">
        <h2 *ngIf="displayPromotionMessage" class="special-products-two--title-inner">{{promotionMessage}}</h2>
    </div>
    <div class="special-products-two--grid">
        <div>
            <ng-container *ngFor="let product of products | slice:0:2">
                <pdp-product-box-vertical-two [company]="company" [product]="product"></pdp-product-box-vertical-two>
            </ng-container>
        </div>
        <div class="product-box product-box-special-two">
            <ng-container class="product-wrap" *ngFor="let product of products | slice:0:1">
                <pdp-product-box [company]="company" [product]="product"></pdp-product-box>
            </ng-container>
        </div>
        <div>
            <ng-container *ngFor="let product of products | slice:2:4">
                <pdp-product-box-vertical-two [company]="company" [product]="product"></pdp-product-box-vertical-two>
            </ng-container>
        </div>
    </div>
</section>